/**
 * API Le Dilemme du jour — fetch + post.
 *
 * Le backend Axum sert les routes :
 *   GET  /api/daily/:date     → { date, decision_id, total_votes, counts: [{option_id, count}] }
 *   POST /api/daily/:date/vote → idem après enregistrement du vote
 *
 * La route /jour ne charge JAMAIS le WASM — c'est la condition du
 * format métro 90 secondes (cf. project_dilemme_du_jour.md).
 */

export interface DilemmaAggregate {
  date: string;
  decision_id: string;
  total_votes: number;
  counts: { option_id: string; count: number }[];
}

/** Date du jour au format YYYY-MM-DD (heure locale du navigateur). */
export function todayIsoDate(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export async function fetchDilemma(date: string): Promise<DilemmaAggregate> {
  const r = await fetch(`/api/daily/${date}`);
  if (!r.ok) throw new Error(`fetchDilemma: HTTP ${r.status}`);
  return r.json();
}

export async function postVote(
  date: string,
  optionId: string,
  sessionUuid: string,
): Promise<DilemmaAggregate> {
  const r = await fetch(`/api/daily/${date}/vote`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ option_id: optionId, session_uuid: sessionUuid }),
  });
  if (r.status === 409) throw new Error("ALREADY_VOTED");
  if (!r.ok) throw new Error(`postVote: HTTP ${r.status}`);
  return r.json();
}
